import { extendDefaults, getUniqId } from '../helpers';
import DB from './stratis-db';
import StratisFactory from './stratis-factory';

export default class StratisElementAbstract {
    constructor(element) {
        this.element = element;
        this._id = getUniqId();
        this._created = false;
        this.options = {};

        // Add id attribute for DOM element.
        this.element.setAttribute('data-db-id', this._id);

        // Save instance to DB.
        DB.save(this.constructor.name, this);
    }

    /**
     * Merge user options with default.
     * @param {object} options - custom user options.
     */
    setOptions(...options) {
        this.options = extendDefaults(this.options, ...options);
    }

    /**
     * Add new property to instance.
     * @param {string} prop - property name
     * @param {*} value - property value
     */
    setProp(prop, value) {
        this[prop] = value;
    }

    /**
     * Get property value.
     * @param {string} prop - property name.
     */
    getProp(prop) {
        return this[prop];
    }

    /**
     * Delete instance from DB.
     */
    delete() {
        DB.delete(this._id, this.constructor.name);
    }
}
